export default "__VITE_ASSET__CmTSGytW__"